export const COOKIE_OPTS = {
  maxAge: 5184000, // 60 days
  sameSite: 'lax' as const,
  secure: true,
}
export const HTTP_ONLY_COOKIE_OPTS = { ...COOKIE_OPTS, httpOnly: true }
